<template>
  <div class="col-lg-8">
    <div class="row">
      <div class="col-12">
        <div class="dash-pro-item mb-30 dashboard-widget">
          <div class="header d-flex justify-content-between align-items-center">
            <h4 class="title" v-if="getUsuarioInfo.tipoPessoa == 'PJ'">Informações da Empresa</h4>
            <h4 class="title" v-else>Informações Pessoais</h4>
            <!-- <button type="submit" class="custom-button" id="edit-button" @click="onEdit()">Editar</button> -->
            <span class="edit" @click="onEdit()"><i class="flaticon-edit"></i>&nbsp;Editar</span>
          </div>
          <ul class="dash-pro-body">
            <li>
              <div class="info-name text-uppercase" v-if="getUsuarioInfo.tipoPessoa == 'PJ'">Razão Social</div>
              <div class="info-name text-uppercase" v-else>Nome Completo</div>
              <div class="info-value">
                {{ getUsuarioInfo.nomeCompleto }}
              </div>
            </li>
            <li>
              <div class="info-name text-uppercase">Apelido</div>
              <div class="info-value">
                {{ getUsuarioInfo.nomeUsuario }}
              </div>
            </li>
            <li>
              <div class="info-name text-uppercase">Telefones</div>
              <div class="info-value">
                <span v-if="getUsuarioInfo.telefone">{{ getUsuarioInfo.telefone | formatTelefone }}</span>
                <span v-if="getUsuarioInfo.telefoneConvencional"> | {{ getUsuarioInfo.telefoneConvencional | formatTelefone }}</span>
              </div>
            </li>
            <li v-if="getUsuarioInfo.endereco">
              <div class="info-name text-uppercase">Endereço</div>
              <div class="info-value">
                {{ getUsuarioInfo.endereco.logradouro }}
                {{ getUsuarioInfo.endereco.numero }}
                {{ getUsuarioInfo.endereco.complemento }} -

                {{ getUsuarioInfo.endereco.bairro }}, {{ getUsuarioInfo.endereco.cidade }} - {{ getUsuarioInfo.endereco.estado }} - CEP:
                {{ getUsuarioInfo.endereco.cep }}
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div class="col-12" v-if="getUsuarioInfo?.responsavel && getUsuarioInfo.tipoPessoa == 'PJ'">
        <div class="dash-pro-item mb-30 dashboard-widget">
          <div class="header d-flex justify-content-between align-items-center">
            <h4 class="title">Informações do Responsável</h4>
            <!-- <button type="submit" class="custom-button" id="edit-button" @click="onEdit()">Editar</button> -->
            <span class="edit" @click="onEdit()"><i class="flaticon-edit"></i>&nbsp;Editar</span>
          </div>
          <ul class="dash-pro-body">
            <li>
              <div class="info-name text-uppercase">Nome</div>
              <div class="info-value">
                {{ getUsuarioInfo.responsavel.nomeCompleto }}
              </div>
            </li>
            <li>
              <div class="info-name text-uppercase">CPF</div>
              <div class="info-value">
                {{ getUsuarioInfo?.responsavel?.numeroDocumento }}
              </div>
            </li>
            <li>
              <div class="info-name text-uppercase">Nascimento</div>
              <div class="info-value">
                {{ getUsuarioInfo.responsavel.dataNascimento | formatData }}
              </div>
            </li>
            <li>
              <div class="info-name text-uppercase">Celular</div>
              <div class="info-value">
                {{ getUsuarioInfo.responsavel.telefoneCelular | formatTelefone }}
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div class="col-12">
        <div class="dash-pro-item mb-30 dashboard-widget">
          <div class="header">
            <h4 class="title">Documentos</h4>
            <!-- <span class="edit"><i class="flaticon-edit"></i> Editar</span> -->
          </div>
          <ul class="dash-pro-body">
            <li v-for="doc in getUsuarioInfo.documentos" :key="doc.documentoId">
              <div v-if="['CPF', 'CNPJ', 'RG'].includes(doc.tipo)" class="info-name text-uppercase">
                {{ doc.tipo }}
              </div>
              <div v-if="['CPF', 'CNPJ', 'RG'].includes(doc.tipo)" class="info-value">
                {{ doc.numeroDocumento }}
              </div>
              <div v-if="doc.tipo == 'RG'" class="pl-2 info-name text-uppercase">ORGÃO EMISSOR</div>
              <div v-if="doc.tipo == 'RG'" class="info-value">
                {{ doc.orgaoEmissor }}
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-12">
        <div class="dash-pro-item mb-30 dashboard-widget">
          <div class="header">
            <h4 class="title">Conta</h4>
            <span class="edit" @click="trocarSenha()"><i class="fa fa-lock"></i>&nbsp;Trocar Senha</span>
          </div>
          <ul class="dash-pro-body">
            <li>
              <div class="info-name text-uppercase">Email</div>
              <div class="info-value">{{ getUsuarioInfo.email }}</div>
            </li>
            <li>
              <div class="info-name text-uppercase">Senha</div>
              <div class="info-value">********</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  name: 'Perfil',
  data() {
    return {
      colorPrimary: process.env.VUE_APP_PRIMARY_COLOR,
      colorSecondary: process.env.VUE_APP_SECONDARY_COLOR,
      colorConstrast: process.env.VUE_APP_CONSTRAST_COLOR,
    };
  },
  computed: {
    ...mapGetters(['getUsuarioInfo']),
  },
  methods: {
    ...mapActions(['info']),

    onEdit() {
      this.$router.replace('edit-perfil');
    },
    trocarSenha() {
      this.$router.replace('trocar-senha');
    },
  },
  created() {
    this.info();
  },
  filters: {
    formatData(data) {
      if (data) return data.substring(0, 10).split('-').reverse().join('/');
    },
    formatTelefone(tel) {
      if (!tel || tel.length < 11) return '';

      if (typeof tel !== 'string') tel = tel.toString();

      tel = tel.replace(/\D/g, '');

      return tel.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    },
  },
};
</script>

<style>
#edit-button {
  height: 50px;
  font-size: 0.9rem;
  background-color: v-bind(colorPrimary);
  color: v-bind(colorConstrast);
}
</style>
